import { Component, Host, h, Prop } from '@stencil/core';
import { stringTruncate } from '../../utils/helpers';

@Component({
  tag: 'vds-header-slide-content',
  styleUrl: 'vds-header-slide-content.scss',
  shadow: true,
})
export class VdsHeaderSlideContent {

  /**
   * Content Slide Headline
   */
  @Prop() headline: string = '';

  render() {
    const { headline } = this;

    return (
      <Host>
        <div class="flex flex-col h-full w-full justify-center">
          <h3 class="inline-block text-grey font-heavy text-3xl leading-8 sm:text-[30px] sm:leading-[32px] uppercase mb-4 break-words"
              innerHTML={ stringTruncate(headline, 70) }></h3>
          <slot></slot>
        </div>
      </Host>
    );
  }

}
